module.exports = __webpack_public_path__ + "img/alert_empty.caeab472.png";